import { cn } from '@/lib/utils'

export interface FilterOption {
  value: string
  label: string
  count?: number
}

interface TableFilterBarProps {
  filters: Array<{
    key: string
    label: string
    options: FilterOption[]
    value: string
  }>
  onFilterChange: (key: string, value: string) => void
}

export function TableFilterBar({ filters, onFilterChange }: TableFilterBarProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-4">
      {filters.map((filter) => (
        <div key={filter.key} className="flex items-center gap-2">
          <span className="text-xs font-medium text-neutral-500">{filter.label}</span>
          <div className="flex items-center gap-1 rounded-lg border border-neutral-200 bg-white p-0.5">
            {filter.options.map((option) => (
              <button
                key={option.value}
                onClick={() => onFilterChange(filter.key, option.value)}
                className={cn(
                  'rounded-md px-2.5 py-1 text-xs font-medium transition-all',
                  filter.value === option.value
                    ? 'bg-primary text-white shadow-sm'
                    : 'text-neutral-600 hover:bg-neutral-50',
                )}
              >
                {option.label}
                {option.count != null && (
                  <span className={cn(
                    'ml-1',
                    filter.value === option.value ? 'text-white/70' : 'text-neutral-400',
                  )}>
                    {option.count}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
